// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 218) return "static/chunks/218.7797a1ea3c961ae6.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 730 ? "44530001" : chunkId) + "-" + {"650":"f952836b96780414","730":"5e813612ba0e80a4"}[chunkId] + ".js";
};